// 数据统计api
import request from "@/utils/request";

// 调拨物料排行
export function queryMaterialRank(params) {
  return request({
    url: "/dataBoard/allocateQuantityRank",
    method: "get",
    params,
  });
}

// 调拨数量趋势
export function queryTrend(params) {
  return request({
    url: "/statistics/getAllocateTrend",
    method: "get",
    params,
  });
}

// 库存列表
export function queryInventoryTable(params) {
  return request({
    url: "/statistics/getInventoryListStatistics",
    method: "get",
    params,
  });
}

// 库存数量排行
export function queryInventoryRank() {
  return request({
    url: "/statistics/getInventoryRankStatistics",
    method: "get",
  });
}

// 头部bar（数据卡片）
export function queryInventoryBlock() {
  return request({
    url: "/dataBoard/quantityStatistics",
    method: "get",
  });
}

// 库存数量折线图
export function quantityLineChart(params) {
  return request({
    url: "/dataBoard/quantityLineChart",
    method: "get",
    params
  });
}

//出库数量饼图
export function outQuantityPieChart(params) {
  return request({
    url: "/dataBoard/outQuantityPieChart",
    method: "get",
    params
  })
}

// 调拨数量柱状图
export function allocateQuantityChart(params) {
  return request({
    url: "/dataBoard/allocateQuantityChart",
    method: "get",
    params
  })
}
